export const folioConfig = {
  getFolios: {
    key: "getFolios",
    url: "/api/v1/folio",
    method: "GET",
    options: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      cacheTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
  getFolio: {
    key: "getFolio",
    url: (data) => {
      const base = `/api/v1/folio/bookings/${data.bookingId}`;
      return data.invoiceNumber
        ? `${base}?invoiceNumber=${encodeURIComponent(data.invoiceNumber)}`
        : base;
    },
    method: "GET",
    options: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    },
  },
  getPaymentTransactions: {
    key: "getPaymentTransactions",
    url: (data) => `/api/v1/folio/bookings/${data.bookingId}/transactions`,
    method: "GET",
    options: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      cacheTime: 1000 * 60 * 5,
    },
  },
  addManualCharge: {
    key: "addManualCharge",
    url: (data) => `/api/v1/folio/bookings/${data.bookingId}/charges`,
    method: "POST",
    options: {
      invalidateKeys: ["getFolio"],
    },
  },
  getAllInvoices: {
    key: "getAllInvoices",
    url: (data) => {
      const base = `/api/v1/folio/${data.folioId}/invoices`;
      return data.invoiceNumber
        ? `${base}?invoiceNumber=${encodeURIComponent(data.invoiceNumber)}`
        : base;
    },
    method: "GET",
    options: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    },
  },
  recordPaymentWithTransactions: {
    key: "recordPaymentWithTransactions",
    url: "/api/v1/folio/payments",
    method: "POST",
    options: {
      invalidateKeys: ["getFolio"],
      onSuccessMessage: "Payment recorded successfully",
      onErrorMessage: "Failed to record payment",
    },
  },
  updateFolioItem: {
    key: "updateFolioItem",
    url: (data) => `/api/v1/folio/items/${data.itemId || data.id}`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getFolio"],
    },
  },
  removeFolioItem: {
    key: "removeFolioItem",
    url: (data) => `/api/v1/folio/items/${data.itemId || data.id}`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getFolio"],
    },
  },
};
